module.exports = "/_next/static/images/DashboardLocation-908e09d7fc3682db1bddb85d36322248.png";